import React from 'react';
import UserUploadsPageBody from '../components/userUploads/UserUploads';

function UserUploadsPage() {
    return <UserUploadsPageBody />;
}

export default UserUploadsPage;
